if (!customElements.get('kovi-customer-carousel')) {
  customElements.define('kovi-customer-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.desktop = matchMedia('(min-width: 750px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1), options);
      this.querySelector('[data-previous]').addEventListener('click', () => this.move(-1), options);
      this.timer = setInterval(() => {
        if (!this.desktop.matches || this.reduced.matches || document.hidden || this.matches(':hover, :focus-within')) return;
        const rect = this.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < innerHeight) this.move(1);
      }, 8000);
    }
    move(direction) {
      const step = this.track.firstElementChild.getBoundingClientRect().width + 12;
      const max = this.track.scrollWidth - this.track.clientWidth;
      let left = this.track.scrollLeft + direction * step;
      if (direction > 0 && this.track.scrollLeft >= max - 2) left = 0;
      if (direction < 0 && this.track.scrollLeft <= 2) left = max;
      this.track.scrollTo({ left: Math.max(0, Math.min(max, left)), behavior: this.reduced.matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
    }
  });
}
